import { FC } from "react";
import { Controller } from "react-hook-form";
import { FormFeedback, Input } from "reactstrap";
import React from "react";
import { SearchableSelectBoxProps } from "./SelectBox.constant";

const SearchableSelectBox: FC<SearchableSelectBoxProps> = ({
  control,
  name,
  className,
  options,
  onChangeHandler,
  error,
  defaultValue,
  id,
  noValid = false,
  onBlur,
}) => {
  const isValidOption = (value = "") => {
    if (value.length === 0) return true;
    return options.some((option) => option.value === value);
  };

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field }) => {
        return (
          <>
            <Input
              {...field}
              className={className}
              list={`${name}-datalistOptions`}
              id={id ? id : "exampleDataList"}
              placeholder="Arama"
              onBlur={onBlur}
              autoComplete="off"
              invalid={
                !!error || (noValid ? false : !isValidOption(field.value))
              }
              onChange={(e) => {
                field.onChange(e.currentTarget.value);
                onChangeHandler && onChangeHandler(e);
              }}
            />
            <datalist
              id={`${name}-datalistOptions`}
              style={{ overflowY: "auto" }}
            >
              {options.map((option) => {
                return <option value={option.value} />;
              })}
            </datalist>

            {!!error && error ? (
              <FormFeedback type="invalid">{error}</FormFeedback>
            ) : (
              <div style={{ height: "22.5px", width: "100%" }}> </div>
            )}
          </>
        );
      }}
    />
  );
};

export default SearchableSelectBox;
